(function () {
    'use strict';

    angular
        .module('app')
        .controller('PatchNotesController', HelpController);

    function HelpController($scope, $state, toaster, PLMHelpFile, cfpLoadingBar) {
        var model = this;
        model.versions = [];

        var h3 = document.querySelectorAll('h3');
        angular.forEach(h3, function (v) {
            if (v.innerText.trim() !== "") {
                var a = 'p' + v.innerText.replace(/\./g, '');
                v.id = a;
                model.versions.push({ a: a, t: v.innerText });
            }
        });

        model.scroll = function (id) {
            var element = angular.element(document.querySelectorAll('#'+id));
            var top = element[0].parentNode.offsetTop;
            var html = document.getElementsByTagName('html');
            html[0].scrollTop = top;
        };

        /*
        function go(e, l) {
            var active = document.querySelectorAll('.active');
            active.forEach(function (e) {
                e.className = "";
            })
            l.className = 'active';
            var sub = document.getElementsByTagName('html');
            sub[0].scrollTop = e;
        }
        */
        cfpLoadingBar.complete();
    }
})();
